export default [
  {
    path: "/faturamento",
    name: "faturamento",
    label: "Faturamento",
    component: () => import("@/components/home/MenuFaturamento.vue"),
  },
  {
    path: "/faturamento/cadastros",
    name: "faturamento.cadastros",
    label: "Cadastros",
    component: () => import("@/components/faturamento/SubmenuFaturamentoCadastros.vue"),
  },
  {
    path: "/faturamento/relatorios",
    name: "faturamento.relatorios",
    label: "Relatórios",
    component: () => import("@/components/faturamento/relatorios/home-relatorios.vue"),
  },
  {
    path: "/faturamento/relatorios/industria",
    name: "faturamento.relatorios.industria",
    label: "Relatórios da Indústria",
    component: () => import("@/components/faturamento/relatorios/home-relatorios-industria.vue"),
  },
  {
    path: "/faturamento/relatorios/comercio",
    name: "faturamento.relatorios.comercio",
    label: "Relatórios do Comércio",
    component: () => import("@/components/faturamento/relatorios/home-relatorios-comercio.vue"),
  },
  {
    path: "/faturamento/configuracoes",
    name: "faturamento.configuracoes",
    label: "Configurações",
    component: () => import("@/components/faturamento/SubmenuFaturamentoConfiguracoes.vue"),
  },
  {
    path: "/faturamento/nota-fiscal",
    name: "faturamento.nfe",
    label: "Nota Fiscal",
    component: () => import("@/components/faturamento/nfe/SubmenuFaturamentoNotaFiscal.vue"),
  },
  {
    path: "/faturamento/cadastros/clientes/novo",
    name: "faturamento.cadastros.clientes.novo",
    label: "Cadastrar Clientes",
    component: () => import("@/components/faturamento/cadastros/cliente/editor-cliente-geral.vue"),
  },
  {
    path: "/faturamento/cadastros/clientes/editar/:id",
    name: "faturamento.cadastros.clientes.editar",
    label: "Editar Clientes",
    component: () => import("@/components/faturamento/cadastros/cliente/editor-cliente-geral.vue"),
  },
  {
    path: "/faturamento/cadastros/clientes",
    name: "faturamento.cadastros.clientes",
    label: "Clientes",
    component: () => import("@/components/faturamento/cadastros/cliente/clientes.vue"),
  },
  {
    path: "/faturamento/cadastros/clientes-grupos",
    name: "faturamento.cadastros.clientes-grupos",
    label: "Grupos de Clientes",
    component: () => import("@/components/faturamento/cadastros/cliente-grupo/clientes-grupos.vue"),
  },
  {
    path: "/faturamento/nota-fiscal/auto",
    name: "faturamento.auto",
    label: "Automação",
    component: () => import("@/components/faturamento/auto/SubmenuAutoFaturamento.vue"),
  },
  {
    path: "/faturamento/nota-fiscal/auto/templates",
    name: "faturamento.auto.templates",
    label: "Templates Automatizados",
    component: () => import("@/components/faturamento/auto/lista-templates-auto.vue"),
  },
  {
    path: "/faturamento/nota-fiscal/auto/notas",
    name: "faturamento.auto.notas",
    label: "Notas Automatizadas",
    component: () => import("@/components/faturamento/auto/lista-notas-auto.vue"),
  },
  {
    path: "/faturamento/nota-fiscal/templates/cadastro",
    name: "faturamento.nfe.templates.novo",
    label: "Cadastrar Templates",
    component: () => import("@/components/faturamento/configuracoes/templates/editor-template.vue"),
  },
  {
    path: "/faturamento/nota-fiscal/templates/:id/editar",
    name: "faturamento.nfe.templates.editar",
    label: "Editar Template",
    component: () => import("@/components/faturamento/configuracoes/templates/editor-template.vue"),
  },
  {
    path: "/faturamento/nota-fiscal/templates",
    name: "faturamento.nfe.templates",
    label: "Visualizar Templates Cadastrados",
    component: () => import("@/components/faturamento/configuracoes/templates/lista-de-templates.vue"),
  },
  {
    path: "/faturamento/nota-fiscal/fci",
    name: "faturamento.nfe.fci",
    label: "FCI",
    component: () => import("@/components/faturamento/fci/FciEnvios.vue"),
  },
  {
    path: "/faturamento/nota-fiscal/fci/novo",
    name: "faturamento.nfe.fci.novo",
    label: "Gerar FCI",
    component: () => import("@/components/faturamento/fci/FciNovoEnvio.vue"),
  },
  {
    path: "/faturamento/nota-fiscal/fci/:id",
    name: "faturamento.nfe.fci.visualizar",
    label: "Visualizar FCI",
    component: () => import("@/components/faturamento/fci/FciEnvioDetalhe.vue"),
    props: true,
    meta: { permission: "faturamento.nfe.fci" },
  },
  {
    path: "/faturamento/nota-fiscal/templates/implantacao-templates",
    name: "configuracoes.implantacao-templates",
    label: "Templates XML",
    component: () => import("@/components/implantacao/TemplatesXmlPage.vue"),
    meta: { permission: "configuracoes.implantacao-templates" },
  },

  {
    path: "/vendas/gestao-precos/tabela-precos",
    name: "vendas.gestao-precos.tabela-precos",
    label: "Tabelas de Preço",
    component: () => import("@/components/faturamento/configuracoes/tabela-preco/tabelas-preco.vue"),
  },
  {
    path: "/vendas/gestao-precos/tabela-precos/editar/:id",
    name: "vendas.gestao-precos.tabela-precos.editar",
    label: "Editar Tabela de Preço",
    component: () => import("@/components/faturamento/configuracoes/tabela-preco/editor-tabela-preco.vue"),
  },
  {
    name: "faturamento.nfe.gerenciar.novo",
    path: "/faturamento/nota-fiscal/gerenciar/novo",
    label: "Criar Notas Fiscais",
    component: () => import("@/components/faturamento/nfe/NovaNFe.vue"),
  },
  {
    path: "/faturamento/nota-fiscal/gerenciar",
    name: "faturamento.nfe.gerenciar",
    label: "Gerenciar Notas",
    component: () => import("@/components/faturamento/nfe/gerenciar-nfe.vue"),
  },
  {
    path: "/faturamento/nota-fiscal/editar/:id",
    name: "faturamento.nfe.gerenciar.visualizar-detalhes",
    label: "Visualizar Detalhes da Nota Fiscal",
    component: () => import("@/components/faturamento/nfe/gerenciar-nfe-show.vue"),
  },
  {
    path: "/faturamento/nota-fiscal/gerenciar/:id/edit",
    name: "faturamento.nfe.gerenciar.editar",
    label: "Editar Notas Fiscais",
    component: () => import("@/components/faturamento/nfe/NovaNFe.vue"),
  },
  {
    path: "/faturamento/cadastros/servicos/gerenciar",
    name: "faturamento.cadastros.servico",
    label: "Serviços",
    component: () => import("@/components/faturamento/cadastros/servico/gerenciarservico.vue"),
  },
  {
    path: "/faturamento/cadastros/servicos/novo",
    name: "faturamento.cadastros.servico.novo",
    label: "Cadastrar Serviços",
    component: () => import("@/components/faturamento/cadastros/servico/novoservico.vue"),
  },
  {
    path: "/faturamento/cadastros/servicos/editar/:id",
    name: "faturamento.cadastros.servico.editar",
    label: "Editar Serviços",
    component: () => import("@/components/faturamento/cadastros/servico/novoservico.vue"),
  },
  {
    path: "/faturamento/os/novo",
    name: "faturamento.ordem-servico.novo",
    label: "Criar Novas Ordens de Serviço",
    component: () => import("@/components/faturamento/os/novaos.vue"),
  },
  {
    path: "/faturamento/os/editar/:id",
    name: "faturamento.ordem-servico.editar",
    label: "Editar Ordens de Serviço",
    component: () => import("@/components/faturamento/os/novaos.vue"),
  },
  {
    path: "/faturamento/os/gerenciar",
    name: "faturamento.ordem-servico",
    label: "Ordens de Serviço",
    component: () => import("@/components/faturamento/os/gerenciar-os.vue"),
  },
  {
    path: "/faturamento/relatorios/industria/produtos/grupos",
    name: "faturamento.relatorios.industria.grupos-produtos",
    label: "Relatório de Faturamento por Produtos",
    component: () => import("@/components/faturamento/relatorios/relatorio-grupos-produtos.vue"),
  },
  {
    path: "/faturamento/relatorios/industria/clientes/produto",
    name: "faturamento.relatorios.industria.clientes-produto",
    label: "Relatório de Clientes por Produto",
    component: () => import("@/components/faturamento/relatorios/relatorio-clientes-produto.vue"),
  },
  {
    path: "/faturamento/relatorios/industria/rentabilidade/linhas",
    name: "faturamento.relatorios.industria.rentabilidade-linhas",
    label: "Relatório de Rentabilidade por Linhas",
    component: () => import("@/components/faturamento/relatorios/relatorio-rentabilidade-linhas.vue"),
  },
  {
    path: "/faturamento/relatorios/comercio/vendas/vendedores",
    name: "faturamento.relatorios.comercio.vendas-vendedores",
    label: "Relatório de Vendas por Vendedores",
    component: () => import("@/components/faturamento/relatorios/vendas-vendedores.vue"),
  },
  {
    path: "/faturamento/relatorios/comercio/metas/vendedores",
    name: "faturamento.relatorios.comercio.metas-vendedores",
    label: "Relatório de Metas por Vendedores",
    component: () => import("@/components/faturamento/relatorios/metas-vendedores.vue"),
  },
  {
    path: "/faturamento/relatorios/industria/grupos-produtos-periodo",
    name: "faturamento.relatorios.industria.grupos-produtos-periodo",
    label: "Relatório de Comparação por Periodo de Grupos de Produtos",
    component: () => import("@/components/faturamento/relatorios/relatorio-grupos-produtos-periodo.vue"),
  },
  {
    path: "/faturamento/relatorios/industria/total-vendas-representante-cliente",
    name: "faturamento.relatorios.industria.total-vendas-representante-cliente",
    label: "Relatório de Compras Mensais dos Clientes",
    component: () => import("@/components/faturamento/relatorios/relatorio-vendas-representante-cliente.vue"),
  },
  {
    path: "/faturamento/relatorios/industria/total-vendas-representante-cliente-semanal",
    name: "faturamento.relatorios.industria.total-vendas-representante-cliente-semanal",
    label: "Relatório de Compras Semanais dos Clientes",
    component: () => import("@/components/faturamento/relatorios/relatorio-vendas-representante-cliente-semanal.vue"),
  },
  {
    path: "/faturamento/relatorios/industria/inativos",
    name: "faturamento.relatorios.industria.inativos",
    label: "Relatório de Clientes Inativos",
    component: () => import("@/components/faturamento/relatorios/inativos.vue"),
  },
  {
    path: "/faturamento/relatorios/industria/positivacao",
    name: "faturamento.relatorios.industria.positivacao",
    label: "Relatório de Positivação",
    component: () => import("@/components/faturamento/relatorios/positivacao.vue"),
  },
  {
    path: "/faturamento/relatorios/industria/positivacao/cliente",
    name: "faturamento.relatorios.industria.positivacao-cliente",
    label: "Relatório de Positivação por Cliente",
    component: () => import("@/components/faturamento/relatorios/positivacao-cliente.vue"),
  },
  {
    path: "/faturamento/relatorios/industria/positivacao/produto",
    name: "faturamento.relatorios.industria.positivacao-produto",
    label: "Relatório de Positivação por Produto",
    component: () => import("@/components/faturamento/relatorios/positivacao-produto.vue"),
  },
  {
    path: "/faturamento/relatorios/industria/representante/grupo",
    name: "faturamento.relatorios.industria.grupo-representante",
    label: "Relatório de Equipes",
    component: () => import("@/components/faturamento/relatorios/grupo-representante.vue"),
  },
  {
    path: "/faturamento/relatorios/comercio/custo",
    name: "faturamento.relatorios.comercio.custo",
    label: "Relatório de Custo",
    component: () => import("@/components/controladoria/relatorios/custo.vue"),
  },
  {
    path: "/faturamento/relatorios/industria/rentabilidade",
    name: "faturamento.relatorios.industria.rentabilidade",
    label: "Relatório de Rentabilidade",
    component: () => import("@/components/controladoria/relatorios/rentabilidade.vue"),
  },
  {
    path: "/faturamento/descontos/limite-descontos",
    name: "faturamento.descontos.limite-descontos",
    label: "Gerenciar Limites de Descontos",
    component: () => import("@/components/faturamento/vendas/limite-descontos.vue"),
  },
  {
    path: "/faturamento/precos/descontos",
    name: "e-commerce.vendas.precos.descontos",
    label: "Cadastrar Descontos",
    component: () => import("@/components/faturamento/vendas/descontos.vue"),
  },
  {
    path: "/vendas/gestao-precos/gerenciar-descontos",
    name: "vendas.gestao-precos.gerenciar-descontos",
    label: "Gerenciar Descontos",
    component: () => import("@/components/faturamento/vendas/gerenciar-descontos.vue"),
  },
  {
    path: "/faturamento/relatorios/industria/produtosmaisvendidos",
    name: "faturamento.relatorios.industria.produtos-mais-vendidos",
    label: "Relatório de Produtos Mais Vendidos",
    component: () => import("@/components/faturamento/relatorios/produtos-mais-vendidos.vue"),
  },
  {
    path: "/faturamento/caixa",
    name: "faturamento.caixa",
    label: "Fazer uso do Caixa",
    component: () => import("@/components/faturamento/caixa/ViewCaixa.vue"),
  },
];
